<template>
    <div>
        <div v-if="offers && offers.length">
            <div class="hidden-md-and-up">
                <h3 class="font-weight-bold">{{$t('credit_score.best_offers')}}: </h3>
                <div>
                    <v-list three-line>
                        <template v-for="(item, index) in offers">
                            <v-divider
                                :inset="false"
                                class="pa-0 ma-0"
                                v-if="index !== 0">
                            </v-divider>

                            <v-list-item @click="openOffer(item.affiliate_url, item)" class="pa-0 pl-3">
                                <div class="d-flex flex-column">
                                    <v-list-item-avatar>
                                        <v-img :src="item.img_path"></v-img>
                                    </v-list-item-avatar>
                                    <v-rating v-model="item.rate" half-increments background-color="orange lighten-3"
                                        color="orange" x-small dense readonly class="ml-n4 mt-n2">
                                    </v-rating>
                                </div>
                                <v-list-item-content>
                                    <v-list-item-title class="offer-list-header">{{item.name}}</v-list-item-title>
                                    <v-list-item-subtitle>
                                        <v-row style="margin-left: 2px">
                                            <v-col cols="12" class="ma-0 pa-0">
                                                <span class="text-center mb-0 mb-lg-5">{{$t('success_rate')}}: </span>
                                                <span class="text-center font-weight-bold offer-value">{{item.success_rate}}%</span>
                                            </v-col>
                                            <v-col cols="12" class="ma-0 pa-0">
                                                <span class="text-center mb-0 mb-lg-5">{{$t('percentage_rate')}}: </span>
                                                <span class="text-center font-weight-bold offer-value">{{$t('from_x_percent', {bet: item.bet})}}</span>
                                            </v-col>
                                        </v-row>
                                    </v-list-item-subtitle>
                                    <div class="mt-2 pa-2 hidden-sm-and-up">
                                        <v-btn style="width: 100%" color="primary" small>{{$t('get_money')}}</v-btn>
                                    </div>
                                    <div class="mt-2 pa-2 hidden-xs-only">
                                        <v-btn color="primary" small class="float-right">{{$t('get_money')}}</v-btn>
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-list>
                </div>
            </div>
            <div class="hidden-sm-and-down">
                <h3 class="font-weight-bold mt-4 pb-2 offer-headline">{{$t('credit_score.best_offers')}}: </h3>
                <v-row>
                    <v-col lg="4" md="6" v-for="(item, index) in offers" :key="item.id">
                        <v-hover v-slot:default="{ hover }">
                            <div class="offer-card" :class="{ 'on-hover': hover }">
                                <v-row>
                                    <v-divider vertical v-if="index !== 0" class="hidden-md-and-down mr-4"></v-divider>
                                    <v-col cols="4" align="center" justify="center" class="mt-5">
                                        <v-img :src="item.img_path" width="100px"></v-img>
                                        <v-rating
                                            v-model="item.rate" half-increments background-color="orange lighten-3"
                                            color="orange" small dense readonly class="ml-n4"
                                        ></v-rating>
                                    </v-col>
                                    <v-col>
                                        <div>
                                            <p class=" ma-0">{{$t('success_rate')}}</p>
                                            <p class=" font-weight-bold offer-headline">{{item.success_rate}}%</p>
                                        </div>
                                        <div>
                                            <p class=" ma-0">{{$t('percentage_rate')}}</p>
                                            <p class=" font-weight-bold offer-headline">{{$t('from_x_percent_in_day', {bet: item.bet})}}</p>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pt-0 mt-0">
                                        <div class="float-right">
                                            <v-btn color="primary" elevation="0" small @click="openOffer(item.affiliate_url, item)">{{$t('get_money')}}</v-btn>
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-hover>
                    </v-col>
                </v-row>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'OfferCardsTemplate',
        data() {
            return {
                utm_source: 'credit_score'
            }
        },
        computed: {
            offers() {
                return this.$store.getters.CS_OFFERS;
            },
        },
        methods: {
            openOffer(url, offer) {
                let chosen_offer = {
                    offer: offer.id,
                    sum: this.price,
                    days: this.days,
                    aff_sub3: offer.lead_uuid,
                    pattern_id: offer.pattern_id
                };
                this.$store.dispatch('CHOSE_OFFER', chosen_offer);

                var re = new RegExp("\A?aff_sub4=[^&]+", "i");
                if (url.match(re)) {
                    url = url.replace(re, "aff_sub4=credit_score");
                } else {
                    re = new RegExp("\A?s4=[^&]+", "i");
                    if (url.match(re)) {
                        url = url.replace(re, "s4=credit_score");
                    }
                }
                window.open(url, '_blank');
            },
        }
    }
</script>

<style>
    .offer-list-header {
        font-size: 16px !important;
        font-weight: 500 !important;
    }
    .offer-value {
        font-size: 16px !important;
    }
    .offer-headline {
        font-size: 20px !important;
    }
</style>
